import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';

export interface IPatientTaskNoteEditValidated {
    text: string;
}

export interface IPatientTaskNoteAddValidated extends IPatientTaskNoteEditValidated {
    practitionerId: string | null;
    taskId: string;
}

const patientTaskNoteEdit = Koi.object({
    text: Koi.string().required(),
});

export const patientTaskNoteAddSchema: ISchemaContainer<IPatientTaskNoteAddValidated> = {
    schema: patientTaskNoteEdit.keys({
        practitionerId: Koi.string().uuid().optional(),
        taskId: Koi.string().uuid(),
    }),
};

export const patientTaskNoteEditSchema: ISchemaContainer<IPatientTaskNoteEditValidated> = {
    schema: patientTaskNoteEdit,
};
